import React, {useState} from "react";
import { IconButton, Popover, Box, Typography, Slider} from "@mui/material";
import ExploreIcon from "@mui/icons-material/Explore";
import CloseIcon from "@mui/icons-material/Close";
import northControlStyle from "./northControlStyle";
import Tooltip from "@mui/material/Tooltip";

const NorthControl = ({ viewerRef }) => {
    const classes = northControlStyle();
    const [anchorEl, setAnchorEl] = useState(null);
    // Default tilt
    const [tilt, setTilt] = useState(10);
    //Default Heading
    const [heading, setHeading] = useState(0);
    const [initialCamera, setInitialCamera] = useState(null);

    // Save initial camera position
    React.useEffect(() => {
        if (viewerRef.current?.scene?.camera && !initialCamera) {
            const camera = viewerRef.current.scene.camera;
            setInitialCamera({
                eye: [...camera.eye],
                look: [...camera.look],
                up: [...camera.up],
            });
        }
    }, [viewerRef]);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Close the popover menu
    const handleClose = () => {
        setAnchorEl(null);
    };

    // Handle tilt slider change
    const handleTiltChange = (event, newValue) => {
        setTilt(newValue);
        if (viewerRef.current?.scene?.camera) {
            const camera = viewerRef.current.scene.camera;
            const tiltAngle = (90 - newValue) * (Math.PI / 180);
            const radius = Math.max(camera.eyeLookDist, 20);

            const dx = radius * Math.sin(tiltAngle);
            const dy = radius * Math.cos(tiltAngle);

            camera.eye = [
                camera.look[0],
                camera.look[1] + dy,
                camera.look[2] + dx
            ];

            camera.up = [0, 1, 0];
            //prevent clipping issues
            camera.perspective.near = Math.max(0.1, radius * 0.05);
        };
    };

    // Handle heading slider change
    const handleHeadingChange = (event, newValue) => {
        setHeading(newValue);
        if (viewerRef.current?.scene?.camera) {
            viewerRef.current.scene.camera.orbitYaw(newValue - heading);
        }
    };

    // Reset tilt and heading
    const handleReset = () => {
        if (viewerRef.current?.scene?.camera && initialCamera) {
            const camera = viewerRef.current.scene.camera;
            camera.eye = [...initialCamera.eye];
            camera.look = [...initialCamera.look];
            camera.up = [...initialCamera.up];
        }
        setTilt(10);
        setHeading(0);
    };

    return (
        <div className={classes.container}>

            {/* North Button */}
            <div className={classes.northButtonContainer}>
                <Tooltip title= "Tilt and Heading Controls" arrow>
                    <IconButton className={classes.northButton} onClick={handleOpen}>
                        <ExploreIcon className={classes.compassIcon}/>
                    </IconButton>
                </Tooltip>
            </div>

            {/* Popover Menu */}
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                transformOrigin={{ vertical: "bottom", horizontal: "center" }}
                className={{ paper: classes.popoverContainer }}
                elevation={0}
            >
                <Box className={classes.popoverContent}>
                    {/* Close Button */}
                    <IconButton className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    {/* Tilt Slider */}
                    <div className={classes.sliderRow}>
                        <Typography className={classes.label}>Tilt</Typography>
                        <Slider
                            className={classes.slider}
                            value={tilt}
                            onChange={handleTiltChange}
                            min={0}
                            max={89}
                            step={1}
                        />
                    </div>
                    <div className={classes.sliderRow}>
                        {/* Heading Slider */}
                        <Typography className={classes.label}>Heading</Typography>
                        <Slider
                            className={classes.slider}
                            value={heading}
                            onChange={handleHeadingChange}
                            min={-180}
                            max={180}
                            step={1}
                        />
                    </div>

                    {/* Reset to North Button */}
                    <Typography className={classes.resetButton} onClick={handleReset}>
                        Reset View
                    </Typography>
                </Box>
            </Popover>
        </div>
    );
};

export default NorthControl;